import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/App';
import { Leaf, Menu, ShoppingCart, X } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const navigate = useNavigate();
  const { cart, openCart } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => navigate('/')}
          >
            <img
              src="/0middle-logo.svg"
              alt="0middle logo"
              className="w-9 h-9 shrink-0 object-contain"
            />
            <span
              className="text-xl font-semibold leading-none text-primary"
              style={{ fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
            >
              <span
                className="font-bold"
                style={{ fontFamily: "'SF Mono', Menlo, Consolas, monospace", fontVariantNumeric: 'slashed-zero', fontFeatureSettings: "'zero' 1" }}
              >
                0
              </span>
              middle
            </span>
          </div>

          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              onClick={openCart}
              className="relative"
            >
              <ShoppingCart className="w-5 h-5" />
              {cart.length > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-secondary text-secondary-foreground text-xs flex items-center justify-center">
                  {cart.length}
                </span>
              )}
            </Button>

            <Button
              onClick={() => navigate('/admin/login')}
              className="hidden md:flex btn-pill bg-primary text-primary-foreground gap-2"
            >
              <Leaf className="w-4 h-4" />
              Admin
            </Button>

            <Button
              variant="ghost"
              size="icon"
              className="md:hidden"
              onClick={() => setMobileMenuOpen((open) => !open)}
            >
              {mobileMenuOpen ? (
                <X className="w-5 h-5" />
              ) : (
                <Menu className="w-5 h-5" />
              )}
            </Button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-3 border-t border-border">
            <button
              onClick={() => {
                navigate('/admin/login');
                setMobileMenuOpen(false);
              }}
              className="w-full text-left px-3 py-2 rounded-lg text-primary hover:bg-primary/10 flex items-center gap-2 font-medium"
            >
              <Leaf className="w-4 h-4" />
              Admin
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
